import React, { Component } from 'react';
import NavMenu from './NavMenu';
import Footer from './Footer';
import Styles from './layoutStyles.module.scss'
import DiscountReader from '../DiscountReader';
import Notification from '../Notification';

export class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);
        this.state = {
            showNavAndFooter: true,
        };
    }


    componentDidMount() {
        //const pathName = window.location.pathname;
        //const pageName = pathName.split('/').filter(Boolean).pop();
        //const queryParams = new URLSearchParams(window.location.search);

        //if ((pageName && pageName.toLowerCase() === "playroku") || queryParams.has("roku")) {
        //    this.setState({ showNavAndFooter: false });
        //}

    }

    render() {
        return (
            <>
                <Notification />
                <DiscountReader />

                {this.state.showNavAndFooter && <NavMenu />}

                <main tag="main" className={Styles.layout}>
                    {this.props.children}
                </main>

                {this.state.showNavAndFooter && <Footer />}
            </>
        );
    }
}
